import React from 'react'

export default function FormGroupButton() {
    return (
        <div className="form-group">
            <button className="btn btn-g btn-round btn-block btn-lg mt-20" id="rfsubmit" type="submit"><i
                className="fa fa-paper-plane-o"></i> Reserve</button>
        </div>
    )
}
